import React, { useState } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { Layout, Radio } from 'antd';
import { SearchOutlined, FolderOpenOutlined, HistoryOutlined, SettingOutlined } from '@ant-design/icons';

import appLogo from '../../../../assets/icons/genascreen-logo.png'
import './AppLayout.css'

const { Header, Content } = Layout;

const AppLayout = ({ children }) => {
  const [selectedMenu, setSelectedMenu] = useState("home");

  const handleMenuClick = (e) => {
    setSelectedMenu(e.target.value);
  };

  return (
    <Router>
      <Layout className="gs-app-layout">
        {/* Navbar / Header */}
        <Header className="gs-app-header">
          {/* Logo on the Left */}
          <img src={appLogo} alt='Application Logo' style={{ height: '48px' }} />
          {/* Menu on the Right */}
          <Radio.Group value={selectedMenu} onChange={handleMenuClick}>
            <Radio.Button value="search">
              <span className='gs-app-menu-item'><SearchOutlined />Search</span>
            </Radio.Button>
            <Radio.Button value="cases">
              <span className='gs-app-menu-item'><FolderOpenOutlined />Cases</span>
            </Radio.Button>
            <Radio.Button value="history">
              <span className='gs-app-menu-item'><HistoryOutlined />History</span>
            </Radio.Button>
            <Radio.Button value="settings">
              <span className='gs-app-menu-item'><SettingOutlined />Settings</span>
            </Radio.Button>
          </Radio.Group>
        </Header>

        {/* Dynamic Content */}
        <Content className="gs-app-content">
          {children}  {/* This will render any child component passed */}
        </Content>

      </Layout>
    </Router>
  );
};

export default AppLayout;
